import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";

const StyledAccordion = withStyles({
  root: {
    backgroundColor: "transparent",
    border: "1px solid rgba(164, 194, 244, 0.25)",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      marginBottom: "0px",
      marginTop: "0px",
    },
  },
  expanded: {},
})(Accordion);

const StyledAccordionSummary = withStyles({
  root: {
    background: "linear-gradient(135deg, #2b6cb0 0%, #4a8ec2 100%)",
    marginBottom: -1,
    minHeight: 56,
    transition: "filter 0.2s ease",
    "&:hover": {
      filter: "brightness(1.1)",
    },
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "0px ",
    },
  },
  expanded: {},
})(AccordionSummary);

const StyledAccordionDetails = withStyles((theme) => ({
  root: {
    backgroundColor: "#0f1f33",
    padding: theme.spacing(2),
  },
}))(AccordionDetails);

export default function WorkPanel() {
  const [expanded, setExpanded] = React.useState({ panel1: true });

  const handleChange = (panel) => () => {
    setExpanded((prev) => ({ ...prev, [panel]: !prev[panel] }));
  };


  return (
    <div className="workcontainer-component animate fade-in-from-bottom">
      <StyledAccordion
        square
        expanded={!!expanded["panel1"]}
        onChange={handleChange("panel1")}
        TransitionProps={{
          timeout: 100,
        }}
      >
        <StyledAccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <Typography>
            <p className="c4">
              <span
                className={`c20 ${expanded["panel1"] ? "carot-rotated" : ""}`}
              ></span>
              <span className="c9">Senior Developer | Blueprint Interactive</span>
            </p>
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            <p className="c4">
              <span className="c7">July 2020 &ndash; Present</span>
            </p>
            <p className="c4 c10">
              <span className="c13"></span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Develop and maintain dozens of production websites and applications for political, advocacy, and nonprofit clients - from WordPress CMS builds to full React/TypeScript and Python applications
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Lead frontend developer on a greenfield TypeScript/React + FastAPI/PostgreSQL product; own pull-request review and release management
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Primary developer of a long-running, public-facing React/Redux + Django data platform: Redux architecture, Celery/Redis data pipelines, and a solo major-version upgrade (Python 3.12, Django 4.2)
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Develop custom WordPress themes and plugins (ACF, Fluent Forms) and integrate services including Stripe, HubSpot, NGP VAN/EveryAction, SendGrid, and Google APIs
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Troubleshoot production issues across the full stack - Linux, Nginx, Docker, DNS/TLS, AWS, and DigitalOcean
              </span>
            </p>
            <p className="c4 c10">
              <span className="c3"></span>
            </p>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

      <div className="expansion-spacing"></div>

      <StyledAccordion
        square
        expanded={!!expanded["panel2"]}
        onChange={handleChange("panel2")}
        TransitionProps={{
          timeout: 100,
        }}
      >
        <StyledAccordionSummary
          aria-controls="panel2d-content"
          id="panel2d-header"
        >
          <Typography>
            <p className="c4">
              <span
                className={`c20 ${expanded["panel2"] ? "carot-rotated" : ""}`}
              ></span>
              <span className="c9">Founder & Lead Developer | BRO / Brotech LLC</span>
            </p>
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            <p className="c4">
              <span className="c7">January 2015 &ndash; Present</span>
            </p>
            <p className="c4 c10">
              <span className="c13"></span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Founded BRO, a native iOS (Swift) and Android (Java) social app with 1,000,000+ downloads worldwide, backed by a PHP REST API on AWS
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Personally coded the 2026 4.0 relaunch across all three codebases: StoreKit 2 and Google Play Billing subscriptions, UI redesign, push and deep links, and nine-language localization
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Own and modernize the production backend: PHP 8.3 migration, Redis caching, MariaDB schema design, and an ~80% AWS cost reduction
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Direct distributed developers, designers, and QA across 50+ Agile sprint cycles (Jira, GitHub, Trello)
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Built trust &amp; safety systems: AWS Rekognition image moderation, fraud scoring, and age-gating
              </span>
            </p>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

      <div className="expansion-spacing"></div>

      <StyledAccordion
        square
        expanded={!!expanded["panel3"]}
        onChange={handleChange("panel3")}
        TransitionProps={{
          timeout: 100,
        }}
      >
        <StyledAccordionSummary
          aria-controls="panel3d-content"
          id="panel3d-header"
        >
          <Typography>
            <p className="c4">
              <span
                className={`c20 ${expanded["panel3"] ? "carot-rotated" : ""}`}
              ></span>
              <span className="c9">
                Software Engineering Fellow | General Assembly
              </span>
            </p>
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            <p className="c4">
              <span className="c7">February 2020 &ndash; April 2020</span>
            </p>
            <p className="c4">
              <span className="c13">&nbsp;</span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp;Graduated top of the class in a Full-Stack Software Engineering course with 500+ hours of Computer Science work focused
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; This full-time immersive course focused in-depth on multiple coding languages and frameworks including: HTML, CSS, Javascript, React.js, Node.js, Django, Python, MongoDB, and Express
              </span>
            </p>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

            <div className="expansion-spacing"></div>

      <StyledAccordion
        square
        expanded={!!expanded["panel5"]}
        onChange={handleChange("panel5")}
        TransitionProps={{
          timeout: 100,
        }}
      >
        <StyledAccordionSummary
          aria-controls="panel5d-content"
          id="panel5d-header"
        >
          <Typography>
            <p className="c4">
              <span
                className={`c20 ${expanded["panel5"] ? "carot-rotated" : ""}`}
              ></span>
              <span className="c9">Certified Apple Technician | Apple Inc. </span>
            </p>
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            <p className="c4">
              <span className="c7">August 2008 &ndash; November 2014 </span>
            </p>
            <p className="c5">
              <span className="c13"></span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Provided training, service, and hands-on support for Apple customers&rsquo; hardware and software
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp; Developed weekly training and mentorship plans to support employee growth
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp;Maintained knowledge of Apple&rsquo;s products, software, and services to provide guidance and support to customers{" "}
              </span>
            </p>
            <p className="c6">
              <span className="c1">
                &bull; &nbsp;Recognized for having one of the highest customer satisfaction ratings (NPS) among all technicians in the market
              </span>
            </p>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>
    </div>
  );
}
